export default __webpack_public_path__ + "static/media/degot-screenshot-05.3e404b0d.png";